import React, { useEffect, useState } from 'react';
import CustomTable from '../../../../customComponents/CustomTable';
import { TABLE_DATA, TABLE_HEADERS, keyMapping } from '../../../../../constants/OnboardList';
import './index.scss';
import ListFilters from '../ListFilters';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../services/api/API';
import ROUTES_NAVIGATION from '../../../../../routes/routes';
import ListLogisticsFilters from '../../../Logistics/LogisticsFilter';
import SearchInput from '../../../../customComponents/CustomSearch/SearchInput';
import Loader from '../../../../customComponents/CustomLoader';

const OnboardApproval = () => {
  const [activeSection, setActiveSection] = useState('Customer');
  const [searchTerm, setSearchTerm] = useState('');
  const [totalRecords, setTotalRecords] = useState(0);
  const [ newRequest, setNewRequest ] = useState(0)
  const [ approvedRequest, setApprovedRequest ] = useState(0)
  const [ pendingRequest, setPendingRequest ] = useState(0)
  const [ city, setCity ] = useState([])
  const [ filters, setFilters ] = useState({})
  const [loading, setLoading] = useState(false);
  const [ onBoardList, setOnBoardList ] = useState([])
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [ filterFormData, setFilterFormData ] = useState({})
  const [validationErrors, setValidationErrors] = useState({});

  const token = localStorage.getItem("authToken");

  const navigate = useNavigate();

  const handleSectionChange = (section) => {
    setActiveSection(section);
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchOnBoardApprovalList(newPage);
  };

  useEffect(() => {
    fetchCity()
  },[])

  const fetchCity = async () => {
    try {
      const response = await axiosInstance.post("/bp-onboard/ddlbpcity",{
        business_partner_id: 1,
        onboard_status: 2
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = response.data.data.data; // Access the data from the response object
      const cityOptions = data.map(city => ({
        value: city.ID,
        label: city.NAME,
      }));
      setCity(cityOptions); // Assuming setCity is a state setter function
    } catch (error) {
      console.log(error); // Log the error for debugging purposes
    }
  };

  const renderTableData = () => {
    let filteredData = [];
    switch (activeSection) {
      case 'Customer':
        filteredData = onBoardList
        break;
      case 'Agent':
        filteredData = onBoardList
      
        break;
      case 'Company':
        filteredData = TABLE_DATA.companies.filter(company =>
          Object.values(company).some(value =>
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
          )
        );
        break;
      default:
        filteredData = [];
    }
    return filteredData;
  };

  const renderTableHeaders = () => {
    switch (activeSection) {
      case 'Customer':
        return TABLE_HEADERS.customers;
      case 'Agent':
        return TABLE_HEADERS.agents;
      case 'Company':
        return TABLE_HEADERS.companies;
      default:
        return [];
    }
  };

  const renderKeyMapping = () => {
    switch (activeSection) {
      case 'Customer':
        return keyMapping.customers;
      case 'Agent':
        return keyMapping.agents;
      case 'Company':
        return keyMapping.companies;
      default:
        return [];
    }
  };

  const renderAddButtonLabel = () => {
    switch (activeSection) {
      case 'Customer':
        return 'Add New Customer';
      case 'Agent':
        return 'Add New Agent';
      case 'Company':
        return 'Add New Company';
      default:
        return 'Add New';
    }
  };

  const handleAddButtonClick = () => {
    switch (activeSection) {
      case 'Customer':
        navigate('/admin/manage-onboard/onboard/create-customer');
        break;
      case 'Agent':
        navigate('/admin/manage-onboard/onboard/create-agent');
        break;
      case 'Company':
        navigate('/admin/manage-onboard/onboard/create-company');
        break;
      default:
        break;
    }
  };

  const fetchOnBoardApprovalList = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters
    console.log("allfilteredData",allfilteredData);
    
    try {
      setLoading(true)
      const response = await axiosInstance.post(
        '/bp-onboard/list-approval',
        {
          bp_type_id:"",
          bp_name:"",
          orderBy: 'onboard_id desc',
          page,
          pageSize,
          startDate: allfilteredData?.fromDate?allfilteredData?.fromDate:null ,
          endDate: allfilteredData?.toDate?allfilteredData?.toDate:null ,
          city_id: allfilteredData?.city? allfilteredData?.city :null,
          searchText:searchTerm
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );

     

      const formattedData = response.data.data.data.map((item, index) => {
        localStorage.setItem(`bp_type_${index}`, item.bp_type);
        
        return {
          ...item,
          'Sr No.': index + 1,
        };
      });

      const totalRecordsData = response?.data?.data?.totalRecords
      const approvedReq = response?.data?.data?.total_approve
      const newReq = response?.data?.data?.total_new
      const pendingReq = response?.data?.data?.total_pending

      console.log(totalRecordsData, "RECORDS")
      setTotalRecords(totalRecordsData);

      setPendingRequest(pendingReq)
      setNewRequest(newReq)
      setApprovedRequest(approvedReq)

      setOnBoardList(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error('Error fetching HSN code list:', error);
    }
    finally{
      setLoading(false)
    }
  }


  const handleEdit = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.EDITCUSTOMERAGENTFORM}`, { state: { data: rowData } });
   
  }

  const handleViewDetails = (rowData) => {
    console.log("rowdata>", rowData);
    navigate(`${ROUTES_NAVIGATION.AGENTDETAILS}`, { state: { data: rowData } });
  }

  const clearFilter = () => {
    setFilterFormData({})
    setFilters({});
    fetchOnBoardApprovalList(0, 10);
  };

  const handleSearch = () => {
    console.log("filterFormData",filterFormData);
    
    // Update the filters state with the current form data
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
      city: filterFormData.city_id || null,
    });

  };

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),  
      required: true,
      gridClass: "col-lg-2",
    },
    {
        name: "endDate",
        label: "To Date",
        type: "date",
        maxDate: new Date(),
        required: true,
        gridClass: "col-lg-2",
    },
    {
      name: "city_id",
      label: "City",
      placeholder:"Select City",
      type: "dropdown",
      options: city,
      required: true,
      gridClass: "col-lg-2",
    }
  ]
  useEffect(() => {
    if (searchTerm === "") {
      fetchOnBoardApprovalList();
    }
  }, [searchTerm,filters]);

  return (
    <div>
    {loading ? (
      <Loader />
    ) : (
    <div>
      <div className='OnboardManagamentContainer row'>
        <div className='OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <h5>Onboard Management</h5>
       
        </div>
        <div  className='totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2'>
          <div  className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText"  >{newRequest} </h5>
            <h6>New Request</h6>
          </div>
          <div   className='topleftdataContainer' style={{borderRight: "1px solid lightgrey"}} >
            <h5 className="listTopDataValueText"  >{approvedRequest} </h5>
            <h6>Approved Request</h6>
          </div>
          <div className='topleftdataContainer'>
            <h5 className="listTopDataValueText"  >{pendingRequest} </h5>
            <h6>Pending Request</h6>
          </div>
          <div style={{display:"none"}}>
            <button className='addcustomerbutton' onClick={handleAddButtonClick}>
              {renderAddButtonLabel()}
            </button>
          </div>
        </div>
      </div>
      <ListLogisticsFilters
      formConfig={PhysicalStockTakingInputs} 
      formData={filterFormData}
      setFormData={setFilterFormData}
      validationErrors={validationErrors}
      setValidationErrors={setValidationErrors}
      handleSearch={handleSearch}
      handleClear={clearFilter}
      />

      <div className='tableWrapper'>
        <div className='admin-list-container'>
          <div className='listsearchContainer'>
            <h5>All Approval List</h5>
            <div>
              <SearchInput
                placeholder="Search Business Partner"
                onSearch={fetchOnBoardApprovalList}
                searchTerm={searchTerm}
                setSearchTerm={setSearchTerm}
              />
              </div>
          </div>
        
        </div>

        <CustomTable 
        data={renderTableData()} 
        headers={renderTableHeaders()} 
        keyMapping={renderKeyMapping()} 
        itemsPerPage={10} 
        handleViewButton={handleViewDetails}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        onEdit={handleEdit}
        totalRecords={totalRecords}
        />
      </div>
    </div>
    )}
    </div>
  );
};

export default OnboardApproval;
